import React, { Component } from "react";
import { Card, Row, Col, Form, Button, Container } from "react-bootstrap";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import { toast } from "react-toastify";
import SelectDropDown from "../../selectdropdown/SelectDropDown";
import InsertUnAssigningEmployees from "./insertUnAssigningEmployees";
import CustomButton from "../../../../components/buttons/customButton";

const THEME = {
  primary: "#3b82f6",
  success: "#10b981",
  danger: "#ef4444",
  warning: "#f59e0b",
  text: "#0f172a",
  textMuted: "#64748b",
  border: "#e2e8f0",
  bgCard: "#ffffff",
  bgLight: "#f8fafc",
};

// GraphQL Query for Globals (Branches, Classes, etc.)
const GET_GLOBALS = gql`
  query globals($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      globalBranches {
        id
        branch_name
      }
      classes {
        id
        class
      }
    }
  }
`;

// GraphQL Query for Level Head Employees
const GET_LEVEL_HEAD_EMPLOYEES = gql`
  query getLevelHeadEmployees(
    $employeeId: Int!
    $levelId: Int!
    $branchDepartmentId: String!
  ) {
    getLevelHeadEmployees(
      employeeId: $employeeId
      levelId: $levelId
      branchDepartmentId: $branchDepartmentId
    ) {
      success
      statusCode
      message
      data {
        id
        employee_name
        estatus
      }
    }
  }
`;

const GET_EMPLOYEES_AT_LEVEL = gql`
  query getEmployeesAtLevel(
    $employeeId: Int!
    $levelId: Int!
    $branchDepartmentId: String!
  ) {
    getEmployeesAtLevel(
      employeeId: $employeeId
      levelId: $levelId
      branchDepartmentId: $branchDepartmentId
    ) {
      success
      statusCode
      message
      data {
        id
        employee_name
        estatus
        emp_mobile
        headId
        headName
      }
    }
  }
`;

const REASSIGN_LEVEL_EMPLOYEES = gql`
  mutation reassignLevelEmployees($params: ReassignEmployeesInput!) {
    reassignLevelEmployees(params: $params)
  }
`;

const COLORS = [
  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  "linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%)",
  "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",
  "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
];

// Static Level Options (1 to 6)
const STATIC_LEVELS = [
  { id: 1, user_level: "Level 1" },
  { id: 2, user_level: "Level 2" },
  { id: 3, user_level: "Level 3" },
  { id: 4, user_level: "Level 4" },
  { id: 5, user_level: "Level 5" },
  { id: 6, user_level: "Level 6" },
];

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectBranchDepartmentId: null,
      selectedLevelId: null,
      selectedHeadLevelEmpId: null,
      errors: {},
      selectActionId: 1,
      selectedEmpDeleteUsers: [],
      selectedEmployeeId: null,
      isSubmit: false,
      status: "idle",
      branches: [],
      headEmployees: [],
      isMobile: window.innerWidth <= 600,
      loadingEmployees: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.fetchGlobals();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  fetchGlobals = async () => {
    try {
      if (!this.props.client) {
        console.log("Apollo client not available, using default branches");
        toast.warning("Apollo client not available, using default branches");
        return;
      }

      console.log("Fetching globals...");
      const response = await this.props.client.query({
        query: GET_GLOBALS,
        variables: { institution_id: 51 },
      });

      console.log("Globals response:", response);
      const globalBranches = response.data.globals.globalBranches || [];
      console.log("Fetched branches:", globalBranches);
      this.setState({ branches: globalBranches });
      toast.success(`Loaded ${globalBranches.length} branches`);
    } catch (error) {
      console.error("Error fetching globals:", error);
      toast.warning(`Using default branches - API error: ${error.message}`);
    }
  };

  fetchLevelHeadEmployees = async (levelId, branchDepartmentId) => {
    try {
      console.log("fetchLevelHeadEmployees called with:", {
        levelId,
        branchDepartmentId,
      });

      if (!this.props.client) {
        console.error("Apollo client not available");
        toast.error("Apollo client not available");
        return;
      }

      // Get employee ID from cookies
      const employeeId = parseInt(Cookies.get("id") || "0", 10);
      console.log("Employee ID from cookies:", employeeId);

      if (!employeeId) {
        console.error("Employee ID not found in cookies");
        toast.error("Employee ID not found in cookies");
        return;
      }

      this.setState({ loadingEmployees: true });

      const variables = {
        employeeId: employeeId,
        levelId: parseInt(levelId, 10),
        branchDepartmentId: branchDepartmentId.toString(),
      };

      console.log("API variables:", variables);

      const [headResponse, levelResponse] = await Promise.all([
        this.props.client.query({
          query: GET_LEVEL_HEAD_EMPLOYEES,
          variables: variables,
          fetchPolicy: "network-only",
        }),
        this.props.client.query({
          query: GET_EMPLOYEES_AT_LEVEL,
          variables: variables,
          fetchPolicy: "network-only",
        })
      ]);

      console.log("API response (Heads):", headResponse);
      console.log("API response (Level Employees):", levelResponse);
      
      const headEmployees = headResponse.data.getLevelHeadEmployees.data || [];
      const employeesAtLevel = levelResponse.data.getEmployeesAtLevel.data || [];
      
      console.log("Fetched head employees:", headEmployees);
      console.log("Fetched employees at level:", employeesAtLevel);

      this.setState({
        headEmployees,
        employeesAtLevel,
        loadingEmployees: false,
      });

      if (headResponse.data.getLevelHeadEmployees.success && levelResponse.data.getEmployeesAtLevel.success) {
        toast.success(`Loaded ${employeesAtLevel.length} employees and ${headEmployees.length} potential heads`);
      }
    } catch (error) {
      console.error("Error in fetchLevelHeadEmployees:", error);
      this.setState({ loadingEmployees: false });
      toast.error(`Error: ${error.message}`);
    }
  };

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 600 });
  };

  handleBranchChange = (name, value, selectedOption) => {
    this.setState((prev) => ({
      ...prev,
      selectBranchDepartmentId: selectedOption,
      errors: { ...prev.errors, selectBranchDepartmentId: "" },
    }));
  };

  handleLevelChange = (name, value, selectedOption) => {
    this.setState((prev) => ({
      ...prev,
      selectedLevelId: selectedOption,
      selectedHeadLevelEmpId: null,
      errors: { ...prev.errors, selectedLevelId: "" },
    }));
  };

  handleHeadChange = (name, value, selectedOption) => {
    this.setState((prev) => ({
      ...prev,
      selectedHeadLevelEmpId: selectedOption,
      errors: { ...prev.errors, selectedHeadLevelEmpId: "" },
    }));
  };

  handleNewHeadChange = (name, value, selectedOption) => {
    this.setState((prev) => ({
      ...prev,
      selectedEmployeeId: selectedOption,
      errors: { ...prev.errors, selectedEmployeeId: "" },
    }));
  };

  getHeadEmployeeOptions = () => {
    const { selectedLevelId, headEmployees } = this.state;
    if (!selectedLevelId || !selectedLevelId.value) return [];

    const currentLevel = parseInt(selectedLevelId.value);
    if (currentLevel <= 1) return [];

    // Return head employees fetched from API
    return headEmployees.map((emp) => ({
      value: emp.id,
      label: emp.employee_name,
    }));
  };

  getBranchOptions = () => {
    const { branches } = this.state;
    return branches.map((branch) => ({
      value: branch.id,
      label: branch.branch_name || branch.name || "Unnamed Branch",
    }));
  };

  getLevelOptions = () => {
    return STATIC_LEVELS.map((level) => ({
      value: level.id,
      label: level.user_level,
    }));
  };

  getLevelWiseEmployees = () => {
    const { employeesAtLevel } = this.state;
    return employeesAtLevel || [];
  };

  getHeadEmployeeName = (headId) => {
    if (!headId) return "No Head Assigned";
    const { headEmployees, employeesAtLevel } = this.state;
    
    // First check if it's in headEmployees
    const headEmp = headEmployees.find((emp) => emp.id === headId);
    if (headEmp) return headEmp.employee_name;

    // Then check if the employee itself has the headName
    const employeeWithHead = employeesAtLevel?.find(emp => emp.headId === headId && emp.headName);
    if (employeeWithHead) return employeeWithHead.headName;
    
    return "Unknown";
  };

  handleSubmit = async (e) => {
    console.log("==== HANDLESUBMIT START ====");
    console.log("Current state:", this.state);
    e.preventDefault();
    const {
      selectBranchDepartmentId,
      selectedLevelId,
      selectedHeadLevelEmpId,
    } = this.state;

    console.log("Extracted values:", {
      selectBranchDepartmentId: selectBranchDepartmentId ? "EXISTS" : "MISSING",
      selectedLevelId: selectedLevelId ? "EXISTS" : "MISSING",
      selectedHeadLevelEmpId: selectedHeadLevelEmpId ? "EXISTS" : "MISSING",
    });

    const validations = [
      {
        valid: !!selectBranchDepartmentId,
        message: "Branch is required",
        field: "selectBranchDepartmentId",
      },
      {
        valid: !!selectedLevelId,
        message: "Level is required",
        field: "selectedLevelId",
      },
    ];

    // NOTE: Head employee validation NOT required before API call
    // Head employee dropdown only appears AFTER API returns the list
    // So we just need branch and level to fetch the list

    console.log("Running validations...");
    for (let rule of validations) {
      console.log(`Checking: ${rule.message} - Valid: ${rule.valid}`);
      if (!rule.valid) {
        console.log(`VALIDATION FAILED: ${rule.message}`);
        toast.error(rule.message);
        this.setState({
          errors: { ...this.state.errors, [rule.field]: rule.message },
        });
        return;
      }
    }

    console.log("All validations PASSED!");
    this.setState({ isSubmit: true });

    // Call API to fetch head employees
    const branchId = selectBranchDepartmentId.value;
    const levelId = selectedLevelId.value;

    console.log("About to call fetchLevelHeadEmployees with:", {
      levelId,
      branchId,
    });

    try {
      console.log("Calling fetchLevelHeadEmployees now...");
      await this.fetchLevelHeadEmployees(levelId, branchId);
      console.log("fetchLevelHeadEmployees returned successfully");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Failed to load employees");
    }
    console.log("==== HANDLESUBMIT END ====");
  };

  handleToggleUser = (userId) => {
    this.setState((prev) => {
      const isSelected = prev.selectedEmpDeleteUsers.includes(userId);
      return {
        ...prev,
        selectedEmpDeleteUsers: isSelected
          ? prev.selectedEmpDeleteUsers.filter((id) => id !== userId)
          : [...prev.selectedEmpDeleteUsers, userId],
        selectedEmployeeId: "",
      };
    });
  };

  handleDeleteEmp = async () => {
    const { selectedEmpDeleteUsers, selectedEmployeeId, selectedLevelId, selectBranchDepartmentId } = this.state;
    let errors = {};

    if (selectedEmpDeleteUsers.length === 0) {
      errors.selectedEmpDeleteUsers = "Please select at least one employee";
    }

    if (!selectedEmployeeId) {
      errors.selectedEmployeeId = "Please select a new head";
    }

    if (Object.keys(errors).length > 0) {
      toast.error(Object.values(errors)[0]);
      this.setState({ errors });
      return;
    }

    this.setState({ status: "loading" });

    try {
      const updatedBy = parseInt(Cookies.get("id") || "0", 10);
      const variables = {
        params: {
          employee_ids: selectedEmpDeleteUsers.map(id => parseInt(id, 10)),
          new_head_employee_id: parseInt(selectedEmployeeId.value, 10),
          level_id: parseInt(selectedLevelId.value, 10),
          branch_id: parseInt(selectBranchDepartmentId.value, 10),
          institute_id: parseInt(Cookies.get("institutionid") || "51", 10),
          updated_by: updatedBy
        }
      };

      const response = await this.props.client.mutate({
        mutation: REASSIGN_LEVEL_EMPLOYEES,
        variables
      });

      if (response.data.reassignLevelEmployees) {
        toast.success(`${selectedEmpDeleteUsers.length} employee(s) reassigned successfully`);
        this.setState({ 
          status: "success", 
          selectedEmpDeleteUsers: [], 
          selectedEmployeeId: null 
        });
        
        // Refresh the list
        await this.fetchLevelHeadEmployees(selectedLevelId.value, selectBranchDepartmentId.value);
      } else {
        toast.error("Failed to reassign employees");
        this.setState({ status: "error" });
      }
    } catch (error) {
      console.error("Reassign error:", error);
      toast.error("An error occurred during reassignment");
      this.setState({ status: "error" });
    }
  };

  handleEmptyState = () => {
    this.setState({
      selectBranchDepartmentId: null,
      selectedLevelId: null,
      selectedHeadLevelEmpId: null,
      errors: {},
      selectActionId: 1,
      selectedEmpDeleteUsers: [],
      selectedEmployeeId: null,
      isSubmit: false,
    });
  };

  render() {
    const {
      selectBranchDepartmentId,
      selectedLevelId,
      selectedHeadLevelEmpId,
      selectActionId,
      selectedEmpDeleteUsers,
      selectedEmployeeId,
      isSubmit,
      errors,
      isMobile,
      loadingEmployees,
      headEmployees,
      status,
    } = this.state;

    const levelWiseEmployees = this.getLevelWiseEmployees();
    const headEmpOptions = this.getHeadEmployeeOptions();
    const shouldShowHeadSelect =
      selectedLevelId &&
      parseInt(selectedLevelId.value) > 1 &&
      isSubmit &&
      !loadingEmployees &&
      headEmployees.length > 0;

    return (
      <Container fluid>
        {/* Selection Card */}
        <Card
          style={{
            marginTop: "16px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            backgroundColor: THEME.bgCard,
            border: "none",
          }}
        >
          <Card.Body style={{ padding: "24px" }}>
            <Form onSubmit={this.handleSubmit}>
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: "0 1 240px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: THEME.text,
                    }}
                  >
                    Select Branch
                  </label>
                  <SelectDropDown
                    name="selectBranchDepartmentId"
                    placeholderName="Select Branch"
                    options={this.getBranchOptions()}
                    stateData={selectBranchDepartmentId}
                    handleChange={this.handleBranchChange}
                    isClearable={true}
                  />
                  {errors.selectBranchDepartmentId && (
                    <div
                      style={{
                        color: THEME.danger,
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {errors.selectBranchDepartmentId}
                    </div>
                  )}
                </div>

                <div style={{ flex: "0 1 240px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: THEME.text,
                    }}
                  >
                    Select Level
                  </label>
                  <SelectDropDown
                    name="selectedLevelId"
                    placeholderName="Select Level"
                    options={this.getLevelOptions()}
                    stateData={selectedLevelId}
                    handleChange={this.handleLevelChange}
                  />
                  {errors.selectedLevelId && (
                    <div
                      style={{
                        color: THEME.danger,
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {errors.selectedLevelId}
                    </div>
                  )}
                </div>

                {shouldShowHeadSelect && (
                  <div style={{ flex: "0 1 240px" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontSize: "13px",
                        fontWeight: 600,
                        color: THEME.text,
                      }}
                    >
                      Select Head Employee
                    </label>
                    <SelectDropDown
                      name="selectedHeadLevelEmpId"
                      placeholderName="Select Head"
                      options={headEmpOptions}
                      stateData={selectedHeadLevelEmpId}
                      handleChange={this.handleHeadChange}
                    />
                    {errors.selectedHeadLevelEmpId && (
                      <div
                        style={{
                          color: THEME.danger,
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.selectedHeadLevelEmpId}
                      </div>
                    )}
                  </div>
                )}

                <div style={{ display: "flex", alignItems: "flex-end" }}>
                  <button
                    type="button"
                    onClick={this.handleSubmit}
                    disabled={loadingEmployees}
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "none",
                      backgroundColor: loadingEmployees
                        ? "#9ca3af"
                        : THEME.primary,
                      color: "white",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: loadingEmployees ? "not-allowed" : "pointer",
                      transition: "all 0.2s",
                      opacity: loadingEmployees ? 0.8 : 1,
                    }}
                    onMouseEnter={(e) => {
                      if (!loadingEmployees) {
                        e.target.style.backgroundColor = "#2563eb";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!loadingEmployees) {
                        e.target.style.backgroundColor = THEME.primary;
                      }
                    }}
                  >
                    {loadingEmployees ? (
                      <>
                        <i
                          className="fas fa-spinner fa-spin"
                          style={{ marginRight: "6px" }}
                        ></i>
                        Loading...
                      </>
                    ) : (
                      "Load Employees"
                    )}
                  </button>
                </div>
              </div>
            </Form>
          </Card.Body>
        </Card>

        {/* Action Card */}
        {isSubmit && (
          <Card
            style={{
              marginTop: "16px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              backgroundColor: THEME.bgCard,
              border: "none",
            }}
          >
            <Card.Body style={{ padding: "24px" }}>
              {/* Action buttons */}
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  marginBottom: "24px",
                  flexWrap: "wrap",
                  paddingBottom: "20px",
                  borderBottom: `2px solid ${THEME.border}`,
                }}
              >
                {[
                  { value: 1, label: "👥 View List" },
                  { value: 2, label: "➕ Assign Head" },
                  { value: 3, label: "🔄 Reassign" },
                ].map((item) => (
                  <button
                    key={item.value}
                    onClick={() =>
                      this.setState({
                        selectActionId: item.value,
                        selectedEmpDeleteUsers: [],
                      })
                    }
                    style={{
                      padding: "10px 20px",
                      borderRadius: "8px",
                      border:
                        selectActionId === item.value
                          ? `2px solid ${THEME.primary}`
                          : `1.5px solid ${THEME.border}`,
                      background:
                        selectActionId === item.value
                          ? THEME.primary
                          : THEME.bgLight,
                      color:
                        selectActionId === item.value ? "white" : THEME.text,
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: "14px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = `0 4px 12px ${THEME.primary}20`;
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>

              {/* List View */}
              {selectActionId === 1 && levelWiseEmployees.length > 0 && (
                <div>
                  <h6
                    style={{
                      marginBottom: "24px",
                      fontWeight: 600,
                      fontSize: "16px",
                      color: THEME.text,
                    }}
                  >
                    Employees List ({levelWiseEmployees.length})
                  </h6>
                  <Row className="g-3">
                    {levelWiseEmployees.map((emp, index) => (
                      <Col key={emp.id} xs={12} md={6} lg={4}>
                        <div
                          style={{
                            borderRadius: "12px",
                            padding: "16px",
                            background: COLORS[index % COLORS.length],
                            color: "white",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            transition: "all 0.3s",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "8px",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "16px",
                              }}
                            >
                              {emp.employee_name}
                            </div>
                            <span
                              style={{
                                fontSize: "11px",
                                padding: "2px 8px",
                                borderRadius: "12px",
                                backgroundColor: emp.estatus === 1 ? "rgba(16, 185, 129, 0.2)" : "rgba(239, 68, 68, 0.2)",
                                color: emp.estatus === 1 ? "#ecfdf5" : "#fef2f2",
                                border: emp.estatus === 1 ? "1px solid rgba(16, 185, 129, 0.5)" : "1px solid rgba(239, 68, 68, 0.5)",
                                fontWeight: "bold"
                              }}
                            >
                              {emp.estatus === 1 ? "Active" : "Resigned"}
                            </span>
                          </div>
                          <div style={{ fontSize: "13px", opacity: 0.95 }}>
                            ID: {emp.id}
                          </div>
                          <div
                            style={{
                              fontSize: "13px",
                              opacity: 0.95,
                              marginTop: "4px",
                            }}
                          >
                            Head: {this.getHeadEmployeeName(emp.headId)}
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              )}

              {selectActionId === 1 && levelWiseEmployees.length === 0 && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "48px 24px",
                    color: THEME.textMuted,
                    backgroundColor: THEME.bgLight,
                    borderRadius: "8px",
                  }}
                >
                  No employees found for selected branch and level
                </div>
              )}

              {/* Insert/Assign Head */}
              {selectActionId === 2 && (
                <div style={{ marginTop: "16px" }}>
                  <InsertUnAssigningEmployees
                    stateData={this.state}
                    handleEmptyState={this.handleEmptyState}
                  />
                </div>
              )}

              {/* Reassign */}
              {selectActionId === 3 && levelWiseEmployees.length > 0 && (
                <>
                  <h6
                    style={{
                      marginBottom: "20px",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: THEME.text,
                    }}
                  >
                    Select employees to reassign head
                  </h6>
                  <Row className="g-2" style={{ marginBottom: "16px" }}>
                    {levelWiseEmployees.map((emp) => (
                      <Col key={emp.id} xs={12} md={6} lg={4}>
                        <Form.Check
                          type="checkbox"
                          label={
                            <span>
                              {emp.employee_name}
                              {emp.estatus !== 1 && <span style={{color: 'red', fontSize: '12px', marginLeft: '4px'}}>(Resigned)</span>}
                              {` (Currently: ${this.getHeadEmployeeName(emp.headId)})`}
                            </span>
                          }
                          checked={selectedEmpDeleteUsers.includes(emp.id)}
                          onChange={() => this.handleToggleUser(emp.id)}
                          style={{
                            padding: "8px",
                            borderRadius: "6px",
                            border: "1px solid #e2e8f0",
                          }}
                        />
                      </Col>
                    ))}
                  </Row>

                  {selectedEmpDeleteUsers.length > 0 && (
                    <div
                      style={{
                        marginTop: "16px",
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                        alignItems: "flex-end",
                      }}
                    >
                      <div style={{ flex: "0 1 240px" }}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontSize: "13px",
                            fontWeight: 600,
                            color: THEME.text,
                          }}
                        >
                          Assign New Head
                        </label>
                        <SelectDropDown
                          name="selectedEmployeeId"
                          placeholderName="Select New Head"
                          options={headEmpOptions}
                          stateData={selectedEmployeeId}
                          handleChange={this.handleNewHeadChange}
                        />
                        {errors.selectedEmployeeId && (
                          <div
                            style={{
                              color: THEME.danger,
                              fontSize: "12px",
                              marginTop: "4px",
                            }}
                          >
                            {errors.selectedEmployeeId}
                          </div>
                        )}
                      </div>
                      <div>
                        <CustomButton
                          status={status}
                          onClick={this.handleDeleteEmp}
                          label="Reassign"
                          loadingLabel="Processing..."
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        )}
      </Container>
    );
  }
}

export default withApollo(UserManagement);
